import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BdpService } from '../areas/bdp/bdp.service';
import { ChartsBasicComponent } from '../librarys/components/app-components/sw-charts-basic/charts-basic.component';
import { SwLoadingmaskService } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.service';
import { EventService } from '../librarys/components/basic-components/sw-ng-grid/service/event.service';
import { SystemIdService } from '../librarys/serves/public/system-id.service';
import { SwHttpClientService } from '../librarys/serves/sw-http-client.service';
import { SwJwtService } from '../librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from '../librarys/serves/sw-massage-box.service';
import { SwMenuService } from '../librarys/serves/sw-menu.service';

@Component({
  selector: 'app-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.css']
})
export class ConsoleComponent implements OnInit {

  // @Input() child;
  public draggable = false; //可拖拽
  public resizable = false; //可拉伸
  public colNum = 24;
  public rowHeight = 40;
  public isDraggable = true;
  public isResizable = true;
  public verticalCompact = true;
  public useCssTransforms = true;
  public index = 0; //代表当前id增数
  public responsive = true;
  // public nextId = 19;

  public isMenu: boolean = false; //是否打开菜单(是否编辑模式)
  public isPanel: boolean = false; //组件面板是否打开

  public userWidget: Array<string> = []; //用户的布局组件ID列表,用于做组件只选一次的功能

  public data = []; //所有的组件数据源
  public widgetData = [];//所有组件列表
  public pageBase: any = { orderBy: null } //分页数据
  public deleteList = [];//所有原来有的，后来删除的组件集合
  module: any = {}
  moduleData: any[] = []
  activeModule: string
  searchText: string

  //是否开启自定义布局功能
  enbaleCustomLayout:boolean=environment.enbaleCustomLayout;
  //基础平台微服务api 
  prefix: string = environment.seekerWebAPI;

  constructor(private eventService: EventService,
    private systemId: SystemIdService,
    private box: SwMassageBoxService,
    private bdp: BdpService,
    private menu: SwMenuService,
    private jwt: SwJwtService,
    private swLoadingmaskService: SwLoadingmaskService,  //过渡效果
    private http : SwHttpClientService
  ) {
  }

  ngOnInit() {
    this.init();
  }

  //初始化方法
  init(isInit:boolean=true) {
    let parms = {
      "entity": { systemId: this.systemId.getSystemId() }
    }
    //查询用户工作台布局
    this.http.Post(this.prefix + 'userWidget/queryWidgetList', parms).subscribe(data => {
      if (data["code"] == 200) {
        //先加载用户的组件，再加载组件列表
        let currenData = data["data"].map(item => {
          item.widget.id = this.counter();
          item.widget.isInint=true; //此组件是新增的还是初始化后本来就有的
          item.widget.widgetId = item.widgetId; //接口中的组件对象无widgetId信息，在这里赋予，在charBasic组件中得到
          return {
            "h": item.height,
            "w": item.width,
            "id": item.widgetId,
            "x": item.xAxis,
            "y": item.yAxis,
            'de': item.isDeleted,
            'i': item.widget.id,
            'userWidgetId': item.userWidgetId,
            'componentData': { component: ChartsBasicComponent, data: item.widget },
            auto: false
          }
        });
        this.userWidget = data["data"].map(item => item.widgetId); //映射ID到数组
        this.data = currenData;
        if(isInit){
          //需要重新加载右侧的组件列表时才重新加载
          this.loadWidget();
        }
      }
    }
    )


    //监听组件删除事件
    this.menu.deleteWidget.subscribe(val => {
      let index = this.userWidget.indexOf(val);
      if (index > -1) {
        this.userWidget.splice(index, 1);
      }
    })
  }

  //加载可用组件列表
  loadWidget(widgetName: string = '') {
    let orderByStr = this.pageBase.orderBy;
    //拼接请求对象数据
    let params = {
      "param": { pageNum: this.pageBase.current, pageSize: 0, orderBy: this.pageBase.orderBy },
      "entity": { "widgetName": widgetName, "status": 1, systemId: this.systemId.getSystemId() }
    }
    //请求数据
    this.bdp.getWidgetManageService().queryPageList(params).subscribe(
      data => {
        if (data["code"] == 200) {
          //请求数据 绑定数据
          this.widgetData = data["data"]["records"];
          this.module = {};//清空

          this.widgetData.forEach(v => {
            if (this.module[v.module]) {
              this.module[v.module].push(v)
            } else {
              this.module[v.module] = []
              this.module[v.module].push(v)
            }
          })

          this.moduleData = []; //先清空

          //将此对象处理成数组
          let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
          for (const key in this.module) {
            let keyName = "";
            if (key == "ACTIVITI") {
              keyName = "工作流";
            } else if (key == "BASIC") {
              keyName = "通用";
            } else if (key == "FILE") {
              keyName = "文件";
            } else {
              let dic = [];
              if (dictionary) {
                dic = dictionary.filter(x => x.dictionaryValue == key);
              }
              keyName = dic.length > 0 ? dic[0]["dictionaryName"] : "";
            }
            this.moduleData.push({ module: keyName, children: this.module[key] })
          }
          if (this.moduleData.length > 0) {
            this.activeModule = this.moduleData[0]['module']
          }
          //数据根据module来分类
          //绑定分页属性
          this.pageBase = data["data"];
          this.pageBase.orderBy = orderByStr;

          //在这里执行初始化的逻辑代码
          if (this.data.length == 0) {
            this.swLoadingmaskService.openLoading();
            this.initUserWidget(this.widgetData);
          }
        }
      }
    )
  }

  //在用户没有设置工作门户布局时初始化的方法
  initUserWidget(data: any) {
    //先定义初始化需要的组件code,然后进行筛选出所需的组件
    //用户信息，通知公告，待办，已办，快捷菜单，工作流
    let initArr = ["WGT_USER_INFO", "WGT_SYS_NOTICE", "WGT_TODO_LIST", "WGT_DONE_LIST", "WGT_QUICK_MENU", "WGT_FLOW_LIST"];
    if (data) {
      data.map(x => { 
        x.isInint=true;
        let item={
          widget:x,i:null,
          x:null,y:null,w:null,h:null,userWidgetId:x.userWidgetId,id:x.widgetId,de:x.isDeleted,componentData:{ component: ChartsBasicComponent, data: x }
        }; 
        if (x.widgetCode == initArr[0]) {
          item.i = this.counter();
          //用户信息设置布局
          item.h = 5;item.w = 6;item.x = 0;item.y = 0;
          this.data.push(item);       
        } else if (x.widgetCode == initArr[1]) {
          item.i = this.counter();
          //通知公告设置布局
          item.x = 16;item.y = 8;item.w = 8;item.h = 7;
          this.data.push(item);
        } else if (x.widgetCode == initArr[2]) {
          item.i = this.counter();
          //待办设置布局
          item.x = 3;item.y = 5;item.w = 3;item.h = 3;
          this.data.push(item);
        } else if (x.widgetCode == initArr[3]) {
          item.i = this.counter();
          //已办设置布局
          item.x = 0;item.y = 5;item.w = 3;item.h = 3;
          this.data.push(item);
        } else if (x.widgetCode == initArr[4]) {
          item.i = this.counter();
          //快捷菜单设置布局
          item.x = 0;item.y = 8;item.w = 16;item.h = 7;
          this.data.push(item);
        } else if (x.widgetCode == initArr[5]) {
          item.i = this.counter();
          //工作流设置布局
          item.x = 6;item.y = 0;item.w = 18;item.h = 8;
          this.data.push(item);
        }
      })
    }
    this.saveWidget(true);
  }


  //保存布局
  saveWidget(isInit:boolean=false) {
    //映射成指定格式数组
    let formatData = [...this.data, ...this.deleteList]
    let params = formatData.map(item => {
      return {
        "height": item.h,
        "width": item.w,
        "widgetId": item.id,
        "xAxis": item.x,
        "yAxis": item.y,
        "isDeleted": item.de,
        "userWidgetId": item.userWidgetId
      }
    });

    //let params=[...formatData,...deleteData]; //新增修改的和删除的合并数组
    //请求数据
    this.http.Post(this.prefix + 'userWidget/save', params).subscribe(
      data => {
        this.swLoadingmaskService.closeLoading();
        if (data["code"] == 200) {
          if(isInit){
            this.box.success("工作台初始化成功");
            //刷新用户组件列表，但不用刷新右侧可用组件列表
            this.init(false);
          }else{
            this.isMenu = !this.isMenu;
            //发生改变后调用服务里的方法，通知组件
            this.menu.changePortalStatus(this.isMenu);
             //保存后退出编辑模式
            this.checkDraggable();
            this.checkResizable();
            this.box.success("保存成功");
          }      
        }
      }
    )
  }

  //发生变化时触发
  clickPageQuery(event) {
    this.pageBase = event;
    this.loadWidget();
  }

  checkResponse() {
    this.responsive = !this.responsive;
  }

  //禁用拖拽
  checkDraggable() {
    this.draggable = false;
  }

  //禁用拉伸
  checkResizable() {
    this.resizable = false;
  }
  //新增一个工作台组件
  ///width:宽比例，height：高比例，widgetStyle：图表类型,title：组件标题
  //组件样式，1，列表型，2，数字汇总型，3，报表型，4，快捷菜单型，5，日历型，6，磁贴型
  addItem(modle) {
    if (this.userWidget.indexOf(modle.widgetId) > -1) {
      return false;
    }

    if (this.data.length >= 9) {
      this.box.danger("最多添加9个组件");
      return false;
    }

    let width = 2; //宽比例
    let height = 1;//高比例
    modle.isInint=false;
    if (modle.widgetStyle == 3) {
      //图表默认宽3，高8
        width = 8,
        height = 8;      
    } else if (modle.widgetStyle == 5) {
      //日历默认宽7，高12
        width = 16,
        height = 12;
    } else if (modle.widgetStyle == 6) {
      //磁贴默认宽1，高2
        width = 4,
        height = 3;
    } else if (modle.widgetStyle == 1) {
      //列表默认宽3，高8
        width = 16,                                                             
        height = 6;
    } else if (modle.widgetStyle == 2) {
      //数字汇总型默认宽1，高2
        width = 4,
        height = 3;
    } else if (modle.widgetStyle == 4) {
      //快捷菜单默认宽3，高5
        width = 8,
        height = 7;
    }
    modle.id = this.counter();
    this.eventService._event.emit("addGrid", { 'x': 2, 'y': 0, 'w': width, 'h': height, 'i': modle.id, 'isDraggable': false, 'id': modle.widgetId, 'de': 0, 'componentData': { component: ChartsBasicComponent, data: modle }, auto: false, moved: false });
    this.userWidget.push(modle.widgetId);
  }

  //接收删除时的user_widget_id
  getOutPutData(e) {
    if (e != undefined && e.userWidgetId != undefined && e.userWidgetId != null) {
      //如果有userWidgetId,代表是需要传给后台删除的数据
      e.de = 1;//设置已删除
      this.deleteList.push(e);
    }
  }

  //打开关闭设置菜单
  editMenu() {
    this.isMenu = !this.isMenu;
    //发生改变后调用服务里的方法，通知组件
    this.menu.changePortalStatus(this.isMenu);
    this.draggable = true;
    this.resizable = true;
  }

  openPanel() {
    this.isPanel = !this.isPanel;
  }

  //计数器
  counter() {
    this.index++;
    return this.index;
  }

  clickModule(data) {
    if (this.activeModule == data.module) {
      this.activeModule = ""
    } else {
      this.activeModule = data.module
    }
  }

  search() {
    this.loadWidget(this.searchText);
  }

  reset() {
    this.searchText = "";
    this.loadWidget(this.searchText);
  }

  //还原布局
  reductionWidget(){
    this.init();
    this.isMenu = !this.isMenu;
    //发生改变后调用服务里的方法，通知组件
    this.menu.changePortalStatus(this.isMenu);
     //保存后退出编辑模式
    this.checkDraggable();
    this.checkResizable();
  }
}
